import ruleService from '../../../services/rule.service'


export default {
  async getFolderReceiveMail({ dispatch, commit },data){
    return await ruleService.getFolderReceiveMail(data)
    .then(response => {
        if (response.data){
            const listFolderReceiveMail = response.data
            commit("SET_LIST_FOLDER_RECEIVE_MAIL", listFolderReceiveMail)
            return Promise.resolve(response.data);
        }
        else{
            dispatch("alertError", response.message, { root: true });
        }
    }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
    })
},
async addRuleReceiveMail({ dispatch, commit }, data) {
    return await ruleService.addRuleReceiveMail(data)
      .then(response => {
        if (response.success) {
          if (response.data == true) {
            dispatch("alertSuccess", response.message[0], { root: true });
          }
          else {
            dispatch("alertError", response.message[0], { root: true });
          }
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },

async getRuleReceiveMail({ dispatch, commit },data){
    return await ruleService.getRuleReceiveMail(data)
    .then(response => {
        if (response.data){
            const listRuleReceiveMail = response.data
            commit("SET_LIST_RULE_RECEIVE_MAIL", listRuleReceiveMail)
            return Promise.resolve(response.data);
        }
        else{
            dispatch("alertError", response.message, { root: true });
        }
    }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
    })
},

async deleteRuleReceiveMail({ dispatch, commit }, data) {
    return await ruleService.deleteRuleReceiveMail(data)
      .then(response => {
        if (response.success) {
          dispatch("alertSuccess", response.message[0], { root: true });
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message[0], { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },

async fetchRule ({dispatch}, id) {
    return ruleService.fetchRule(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },

  async updateRuleReceiveMail({ dispatch, commit }, data) {
    return await ruleService.updateRuleReceiveMail(data)
      .then(response => {
        if (response.success) {
          if (response.data == true) {
            dispatch("alertSuccess", response.message[0], { root: true });
          }
          else {
            dispatch("alertError", response.message[0], { root: true });
          }
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },

  async applyRuleReceiveMail({ dispatch, commit },data){
    return await ruleService.applyRuleReceiveMail(data)
    .then(response => {
        if (response.data){
            dispatch("alertSuccess", response.message[0], { root: true });
            return Promise.resolve(response.data);
        }
        else{
            dispatch("alertError", response.message[0], { root: true });
        }
    }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
    })
},

}